import { Controller } from "@hotwired/stimulus"

/**
 * Enables or disables one or more form controls based on a checkbox.
 *
 * Usage:
 *   data-controller="checkbox-disable-controls"
 *   On the checkbox: data-checkbox-disable-controls-target="source"
 *                    data-action="change->checkbox-disable-controls#sync"
 *   On each field:   data-checkbox-disable-controls-target="control"
 *
 * When the checkbox is checked, control targets are enabled; when unchecked, they are disabled
 * (and typically do not submit with the form).
 */
export default class extends Controller {
  static targets = ["source", "control"]

  connect() {
    this.sync()
  }

  sync() {
    const enabled = this.sourceTarget.checked
    this.controlTargets.forEach((el) => {
      el.disabled = !enabled
    })
  }
}
